import React from 'react'
import { useParams } from 'react-router-dom'
import { SingleFarm } from 'src/components/SingleFarm'
import './SingleFarmPage.scss'

export function SingleFarmPage() {
  const { farmName } = useParams<{ farmName: string }>()

  return (
    <div className="farm-page page">
      <SingleFarm farmName={farmName} />
    </div>
  )
}
